import styled from 'styled-components';

export const ChatContainer = styled.div`
  display: flex;

  height: 100%;
  width: 100%;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const ChatMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  max-width: 80%;
`;
